import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import R from "ramda";
import { breakpoint } from "../../breakpoint";

export default class Pager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentBreakpoint: breakpoint()
    };
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.updateBreakpoint);
  }

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateBreakpoint);
  }

  updateBreakpoint = () => {
    this.setState({
      currentBreakpoint: breakpoint()
    });
  }

  handleClick = (page) => {
    const { handleUpdate } = this.props;

    handleUpdate({ "page": page });
  }

  renderBubble = (bubble) => {
    const { page } = this.props;
    const pagesFromPage = "pager__active-" + Math.abs(page - bubble.num)

    const buttonClass = classNames("btn btn--pager ", {
      "pager__active": bubble.current,
      [`${pagesFromPage}`]: true
    });

    return (
      <li key={ bubble.label }>
        <button onClick={() => this.handleClick(bubble.num)} className={ buttonClass } aria-label={"Page " + bubble.label}>{ bubble.label }</button>
      </li>
    );
  }

  render() {
    const { page, perPage, totalResults } = this.props;
    const { currentBreakpoint } = this.state;
    const PAGE_BLOCK_RANGE = (breakpoint().indexOf("small") > -1)
      ? 1
      : (breakpoint().indexOf("large") > -1)
        ? 7
        : 4;

    const numPages = Math.ceil(totalResults / perPage);
    const numPagesVisible = Math.min(numPages, PAGE_BLOCK_RANGE * 2 + 1);
    let start = Math.max(1, page - PAGE_BLOCK_RANGE);
    let end = Math.min(numPages, page + PAGE_BLOCK_RANGE);

    const pages = R.range(start, end + 1);

    const pageArray = pages.map((thisPage) => { return {
      num: thisPage,
      label: thisPage,
      current: thisPage == page
    };});

    const showFutureDots = end + 1 < numPages;
    const showLastPage = end < numPages;
    const showPastDots = start > 2;
    const showFirstPage = start > 1;

    return (
      <div className="search__pager">
        <div className="pager">
          <ul aria-label="page selector">
            { page !== 1
              && (<li><button onClick={() => this.handleClick(page - 1)} className="btn btn--link pager__prev"> Prev</button></li>) }
            { showPastDots
              && <li><button onClick={() => this.handleClick(1)} className="btn btn--pager">1</button></li> }
            { showPastDots
              && <li aria-label="Many more pages exist"><span className="btn btn-disabled btn--link pager__dot-dot-dot">...</span></li> }
            { pageArray.map((page) => this.renderBubble(page)) }
            { showFutureDots
              && <li aria-label="Many more pages exist"><span className="btn btn-disabled btn--link pager__dot-dot-dot">...</span></li> }
            { showLastPage
              && <li><button onClick={() => this.handleClick(numPages)} className="btn btn--pager">{ numPages }</button></li> }
            { page !== numPages
              && (<li><button onClick={() => this.handleClick(page + 1)} className="btn btn--link pager__next">Next </button></li>)}
          </ul>
        </div>
      </div>
    );
  }
}

const { func, number, object } = PropTypes;

Pager.propTypes= {
  handleUpdate: func,
  page: number,
  perPage: number,
  totalResults: number
};
